import { useCallback, useEffect, useState } from "react";
import UsuarioOutput from "../../../usuario/models/UsuarioOutput";
import { useStatusFetch } from "../../../shared/hooks/useStatusFetch";
import http from "../../../../http";
import { useRecarregaAoRenovarToken } from "../../../shared/hooks/useRecarregaAoRenovarToken";

export const useBuscaListaEmails = () => {

  const [listaUsuarios, setListaUsuarios] = useState([])
  const { needFetching } = useStatusFetch(listaUsuarios)

  const buscaListaEmails = useCallback(() => {
    http.get(`/usuarios`)
      .then(res => {
        const resposta = res.data
        const listaDeUsuarios = resposta.map(user => {
          const usuario = UsuarioOutput.create(user)
          return usuario
        })
        setListaUsuarios(listaDeUsuarios) 
      })
      .catch(() => setListaUsuarios([]))
  }, [])

  useEffect(() => {
    if (!needFetching) return
    buscaListaEmails()
    
  }, [needFetching, buscaListaEmails])

  useRecarregaAoRenovarToken(buscaListaEmails)

    return {
      listaUsuarios
    };
  };
